import instance from "../../axios"

export const fetchCategories = params => {
    return async function (dispatch) {
        try {
            const response = await instance(
                `/api/devicetypes?contractNumber=${params.contractNumber || ""}`
            )
            dispatch(getCategories(response))
        } catch (error) {
            console.error("error", error)
        }
    }
}

export const getCategories = types => ({
    type: 'GET_CATEGORIES',
    types
});
export const addCategories = types => ({
    type: 'ADD_CATEGORIES',
    types
});
export const removedCategories = types => ({
    type: 'REMOVED_CATEGORIES',
    types
});